import './Button.scss';

import React, { ReactNode } from 'react';

import { PlayButton } from '../Intro/Intro';

interface ButtonProps {
    children?: ReactNode;
    className?: string;
    type?: 'demo' | 'action';
    onClick?: (event?: React.MouseEvent<HTMLElement, MouseEvent>) => void;
}

export function Button(props: ButtonProps): JSX.Element {
    const type = props.type ?? 'action';

    return (
        <button
            className={['button', props.className, type === 'demo' ? 'buttonDemo' : undefined].join(
                ' '
            )}
            onClick={props.onClick}
        >
            {type === 'demo' && <PlayButton />}
            {props.children}
        </button>
    );
}
